<div class="e-container" style="max-width: 25rem; margin: auto 2rem;">
  <main style="padding-top: 1rem">
    <div class="a-text" style="padding-bottom: 1rem; font-size: 1.25rem; font-weight: 700;">
      <h5>{{'INCIDENT_OVERVIEW.enterLicencePlate' | translate}}</h5>
    </div>
    <div class="a-search-input">
      <input type="search" id="search-input" name="licencePlate" [(ngModel)]="licencePlate"
        (ngModelChange)="onLicencePlateChange($event)" placeholder="e.g.: S T 123" />
      <button type="submit" class="a-search-input__icon-search" (click)="searchLicencePlateEvents()">
        <svg version="1.1" id="Icon_x5F_contour" xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 192 192"
          style="enable-background:new 0 0 192 192;" xml:space="preserve">
          <path d="M170.82861,149.17139l-56.87378-56.87378C117.8075,85.04053,120,76.77307,120,68c0-28.67285-23.32715-52-52-52
            S16,39.32715,16,68s23.32715,52,52,52c8.77307,0,17.04053-2.1925,24.29761-6.04517l56.87378,56.87378
            c3.4502,3.4502,7.91895,5.20068,12.24756,5.2002c3.854,0,7.59717-1.38818,10.40967-4.2002
            C177.79932,165.85742,177.35059,155.69385,170.82861,149.17139z M24,68c0-24.26172,19.73828-44,44-44s44,19.73828,44,44
            s-19.73828,44-44,44S24,92.26172,24,68z M166.17139,166.17139c-1.75098,1.75244-3.87402,1.97852-5.34766,1.85645
            c-2.1709-0.17627-4.35645-1.21729-5.99512-2.85645L99.21613,109.5589c3.91241-2.94604,7.39673-6.43036,10.34277-10.34277
            l55.61249,55.61249c1.63916,1.63867,2.68018,3.82422,2.85645,5.99512C168.14746,162.29688,167.92285,164.42041,166.17139,166.17139z
            "></path>
          <g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g>
        </svg>
      </button>
    </div>
  </main>
</div>
<div class="e-container" style="margin: auto 2rem">
  <main style="padding-top: 2rem">
    <div class="a-text" style="padding-bottom: 1rem; font-size: 1.25rem; font-weight: 700;">
      <h5>{{'INCIDENT_OVERVIEW.incidentHistory' | translate}}</h5>
    </div>
    <ul class="a-option-bar">
      <li class="a-option-bar__item">
        <input type="radio" id="1" name="incident-type" (change)="filterEvents(toggleButtons[0].name)"
          [checked]="isSmokeIncident" />
        <label class="a-option-bar__option" for="1" aria-label="smoke label">
          <span class="a-option-bar__label">{{'INCIDENT_OVERVIEW.smokeIncidents' | translate}}</span>
        </label>
      </li>
      <li class="a-option-bar__item">
        <input type="radio" id="2" name="incident-type" (change)="filterEvents(toggleButtons[1].name)"
          [checked]="isDamageIncident" />
        <label class="a-option-bar__option" for="2" aria-label="damage label">
          <span class="a-option-bar__label">{{'INCIDENT_OVERVIEW.damageIncidents' | translate}}</span>
        </label>
      </li>
      <li class="a-option-bar__item">
        <input type="radio" id="3" name="incident-type" (change)="filterEvents(toggleButtons[2].name)"
          [checked]="isHarshDrivingIncident" />
        <label class="a-option-bar__option" for="3" aria-label="harsh driving label">
          <span class="a-option-bar__label">{{'INCIDENT_OVERVIEW.harshDrivingIncidents' | translate}}</span>
        </label>
      </li>
    </ul>
  </main>

</div>
<div class="e-container" style="max-width: unset; margin: auto 2rem">
  @if (isSmokeIncident) {
    <app-smoke-incident [filter]="licencePlate"></app-smoke-incident>
  }
  @if (isDamageIncident) {
    <app-damage-incident [filter]="licencePlate"></app-damage-incident>
  }
  @if (isHarshDrivingIncident) {
    <app-harsh-driving [filter]="licencePlate"></app-harsh-driving>
  }
</div>

<div
  tabindex="0"
  class="a-chip -icon scroll-top-chip"
  role="button"
  aria-label="Scroll to top"
  (click)="scrollToTop()"
  (keydown)="onScrollToTopKeydown($event)"
>
  <i class="a-icon a-chip__icon boschicon-bosch-ic-arrow-up"></i>
  <span class="a-chip__label">Scroll to top</span>
</div>

